module.exports = __webpack_public_path__ + "static/media/backsplash2.1e11ad69.jpg";